// import { Stack, Typography, useMediaQuery } from "@mui/material";
// import managementConstants from "../../data/about/management.json";
// import { baseurl } from "../../config";

// type Props = {};

// const Management = (props: Props) => {
//   const isSmallScreen = useMediaQuery("(max-width:650px)");
//   return (
//     <Stack direction="column" spacing={2}>
//       <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
//         {managementConstants?.title}
//         <br />
//         <Typography variant="body2" sx={{ fontFamily: "inherit" }}>
//           {managementConstants?.subtitle}
//         </Typography>
//       </Typography>

//       <img
//         src={`${baseurl}${managementConstants?.emblem}`}
//         alt={`${managementConstants?.title}`}
//         width="250px"
//         style={{
//           margin: isSmallScreen ? "1rem auto" : "1.5rem auto",
//           borderRadius: "8px",

//         }}
//       />
//       <Stack direction="column" spacing={2}>
//         {managementConstants?.description?.map(
//           (desc: string, index: number) => (
//             <Typography
//               variant="body2"
//               sx={{ fontFamily: "inherit" }}
//               textAlign="justify"
//               key={index}
//             >
//               {desc}
//             </Typography>
//           )
//         )}
//       </Stack>
//       <Typography
//         variant="body2"
//         textAlign="right"
//         sx={{ fontWeight: "bold", fontFamily: "inherit" }}
//       >
//         {managementConstants?.by}
//       </Typography>
//     </Stack>
//   );
// };

// export default Management;



import { Stack, Typography, useMediaQuery, Box } from "@mui/material";
import managementConstants from "../../data/about/management.json";
import { baseurl } from "../../config";

type Props = {};

const Management = (props: Props) => {
  const isSmallScreen = useMediaQuery("(max-width:650px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  return (
    <Stack direction="column" spacing={2} sx={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
      {/* Title */}
      <Typography
        variant={isSmallScreen ? "h5" : "h4"}
        sx={{ fontFamily: "inherit", textAlign: "center" }}
      >
        {managementConstants?.title}
        <br />
        <Typography
          variant={isSmallScreen ? "body2" : "body1"}
          sx={{ fontFamily: "inherit", textAlign: "center" }}
        >
          {managementConstants?.subtitle}
        </Typography>
      </Typography>

      {/* Content section */}
      <Stack
        direction={isSmallScreen ? "column" : "row"}
        spacing={isSmallScreen ? 1 : 2}
        alignItems="flex-start"
        justifyContent="center"
        sx={{ marginBottom: isSmallScreen ? "1rem" : "2rem" }}
      >
        {/* Image (Main emblem) */}
        <Box
          sx={{
            width: isSmallScreen ? "80%" : "250px",
            height: isSmallScreen ? "auto" : "250px",
            margin: "0 auto",
            borderRadius: "8px",
          }}
        >
          <img
            src={`${baseurl}${managementConstants?.emblem}`}
            alt={`${managementConstants?.title}`}
            width="100%"
            style={{ borderRadius: "8px", objectFit: "cover" }}
          />
        </Box>

        {/* Text */}
        <Stack direction="column" spacing={2} flex={1} textAlign="justify">
          {managementConstants?.description?.map((desc: string, index: number) => {
            const boldTexts = [
              "Our Belief : ",
              "Our Objective : ",
              "A Reflection :",
              "'Knowledge will give you power, but character will give you respect.'",
            ];

            const isBold = boldTexts.some((text) => desc.includes(text));
            return (
              <Typography
                variant={isSmallScreen ? "body2" : "body1"}
                sx={{
                  fontFamily: "inherit",
                  textAlign: "justify",
                  fontWeight: isBold ? "bold" : "normal",
                }}
                key={index}
              >
                {desc}
              </Typography>
            )
          })}

          {/* Sign Image inside the text */}
          <Box
            sx={{
              width: "100%",
              marginTop: "1rem",
              overflow: "hidden",
            }}
          >
            <img
              src="/assets/images/home/image (2).jpg"
              alt="sign-img"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Management;
